import { useAsclepius } from "@/composables/api/asclepius"

const state = () => ({
  ohrCounts: {
    pending: 0,
    missing: 0
  }
})

const getters = {
  totalOhrsNeedingAttention: (state) => {
    return state.ohrCounts.pending + state.ohrCounts.missing
  }
}

const actions = {
  refreshAllCounts({ dispatch }) {
    dispatch("getPendingOhrsCount")
    dispatch("getMissingOhrsCount")
  },

  async getPendingOhrsCount({ commit }) {
    const { getMedicalApi, callWithResponse } = useAsclepius()

    const response = await callWithResponse(() =>
      getMedicalApi().listOccupationalHealthRecords({
        pendingApprovalIn: true
      })
    )

    commit("setPendingOhrsCount", {
      pendingOhrsCount: response.count
    })
  },

  async getMissingOhrsCount({ commit }) {
    const { getMedicalApi, callWithResponse } = useAsclepius()
    const response = await callWithResponse(() => getMedicalApi().listMissingOccupationalHealthRecords())
    commit("setMissingOhrsCount", {
      missingOhrsCount: response.count
    })
  }
}

const mutations = {
  setPendingOhrsCount(state, { pendingOhrsCount }) {
    state.ohrCounts.pending = pendingOhrsCount
  },

  setMissingOhrsCount(state, { missingOhrsCount }) {
    state.ohrCounts.missing = missingOhrsCount
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
